import {
  DeleteOutlined,
  EyeOutlined,
  MenuOutlined,
  NotificationOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Avatar,
  Badge,
  Button,
  Divider,
  Dropdown,
  Image,
  Input,
  Layout,
  Tooltip,
  notification,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { Images } from '../../../controller/Images';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAdminDetail, logout } from '../../../controller/localStroageHandler';
import routes from '../../../controller/Routes';
import { useUserStore } from '../../../store/userReducer';
import { useNotoficationStore } from '../../../store/notificationReducer';
import parse from 'html-react-parser';
import moment from 'moment';
const { Header } = Layout;
const AdminHeader = ({ toggleDrawer }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const { user, updateUserDetail } = useUserStore((state) => state);
  const userdetail=getAdminDetail()
  const { newNotification, notification, updateNotification } =
    useNotoficationStore((state) => state);
  // useEffect(() => {
  //   getCurrentuser()
  //     .then((res) => updateUserDetail(res.data))
  //     .catch((err) => console.log('err ====>', err));
  // }, []);
  const getNotificationData = () => {
    // getNotification()
    //   .then((res) => {
    //     updateNotification(res.data);
    //   })
    //   .catch((err) => console.log('err ====>', err));
  };

  const handleSeen = (id) => {
    // updateseenNotification({ id: id },{is_seen:true})
    //   .then((res) => {
    //     getNotificationData();
    //   })
      // .catch((err) => console.log('err ====>', err));
  };
  const handleDelete=(id)=>{
    // deleteNotification({id:id}).then(res=>{
    //   getNotificationData()
    // }).catch(err=> console.log('err ====>', err))
  }
  return (
    <Header
      className='bg-white d-flex align-items-center justify-content-between gap-2 border-bottom d-lg-none'
      style={{ paddingLeft: '5px', paddingRight: '5px' }}
    >
      <div className=' d-block gap-2 d-lg-none '>
        <Button type='text' icon={<MenuOutlined />} onClick={toggleDrawer} />
        <Image
          src={userdetail?.organization_id?.logo||Images.logo}
          alt=''
          className='logo'
          height={30}
          preview={false}
        />
      </div>
      <div className='d-flex justify-content-center align-items-center gap-2'>
        <Tooltip
          placement='bottomRight'
          color={'white'}
          overlayClassName='notification-tooltip'
          title={
            <div
              className='text-black w-100 d-flex flex-column gap-2 overflow-y-auto'
              style={{ maxHeight: '400px' }}
              onMouseLeave={() => setNotificationOpen(false)}
            >
              {notification?.length ? (
                notification?.map((val, index) => {
                  return (
                    <div
                      className={`d-flex align-items-center gap-1 ${
                        val?.is_seen == false && 'bg-light'
                      }`}
                      key={index}
                    >
                      <Avatar
                        style={{
                          backgroundColor: '#b2d8a7',
                          verticalAlign: 'middle',
                          fontSize: 16,
                          marginRight: '5px',
                        }}
                      >
                        {val?.name?.charAt(0)}
                      </Avatar>
                      <div className='d-flex flex-column fw-normal'>
                        {/* <div dangerouslySetInnerHTML={{ __html: val?.message }} /> */}
                        {parse(val?.message)}
                        <div className='d-flex gap-5'>
                          <span
                            className='text-muted'
                            style={{ fontSize: '12px' }}
                          >
                            {moment(val?.created_at).format('DD-MM-YYYY')}
                          </span>
                          <div className='d-flex gap-2'>
                          {val?.is_seen==false&&<EyeOutlined onClick={() => handleSeen(val?.id)} />}
                            <DeleteOutlined onClick={()=>{handleDelete(val?.id)}}/>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{ height: '10vh' }}
                  className='d-flex justify-content-center align-items-center text-muted'
                >
                  No Notification
                </div>
              )}
            </div>
          }
          open={notificationOpen}
        >
          <Badge count={newNotification}>
            <FontAwesomeIcon
              icon={faBell}
              style={{
                fontSize: 18,
                cursor: 'pointer',
              }}
              onMouseEnter={() => setNotificationOpen(true)}
            />
          </Badge>
        </Tooltip>
        <Divider type='vertical' />
        <Dropdown
          menu={{
            items: [{ label: 'logout', key: 1 }],
            onClick: (val) => {
              if (val?.key == 1) {
                logout();
                navigate(routes.admin.login);
              }
            },
          }}
        >
          <Avatar
            style={{
              backgroundColor: '#b2d8a7',
              verticalAlign: 'middle',
              fontSize: 16,
              marginRight: '10px',
              marginTop: '-6px',
            }}
            className='text-uppercase'
          >
            {userdetail?.firstName?.[0]} {userdetail?.lastName?.[0]}
          </Avatar>
        </Dropdown>
      </div>
    </Header>
  );
};

export default AdminHeader;
